import { render, staticRenderFns } from "./TK.vue?vue&type=template&id=b66d1226&scoped=true&"
import script from "./TK.vue?vue&type=script&lang=js&"
export * from "./TK.vue?vue&type=script&lang=js&"
import style0 from "./TK.vue?vue&type=style&index=0&id=b66d1226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66d1226",
  null
  
)

export default component.exports